angular.module("app").controller("PagesEditItemPageController", [
    '$scope',
    'preloadedItemData',
    'pageStatuses',
    'cropperService',
    'errorHandler',
    'logger',
    'pagesService',
    '$stateParams',
    'settingsService',
    'deepCompare',
    'userStorage',
    'categoryService',
    'aligns',
    'targets',
    function ($scope, preloadedItemData, pageStatuses, cropperService, errorHandler, logger, pagesService, $stateParams, settingsService, deepCompare, userStorage, categoryService, aligns, targets) {

        var settings = settingsService.getSettings(),
            init;

        $scope.userData = userStorage.getUserData();

        $scope.actualPageNames = angular.copy(preloadedItemData.names) || null;

        $scope.aligns = aligns;
        $scope.targets = targets;

        (init = function () {
            $scope.newImageUploaded = null;
            $scope.pageData = angular.copy(preloadedItemData.item);
            $scope.categoryOptions = {
                page_id: $scope.pageData.categoryPageId,
                categories: getSelectedCategories(angular.copy($scope.pageData.categories || []), true)
            };
            $scope.page = preloadedItemData.page;

            $scope.pageStatuses = pageStatuses;
            $scope.vm = {
                dateTimeFrom: $scope.pageData.start_date && new Date($scope.pageData.start_date).toString() || "",
                dateTimeTo: $scope.pageData.end_date && new Date($scope.pageData.end_date).toString() || "",
                created_at: $scope.pageData.created_at && new Date($scope.pageData.created_at).toString() || ""
            };
            $scope.languages = settings.skin.languages;
            $scope.draggedImageDataUrl = "";
            $scope.optionalSettings = {
                hideLanguages: false
            };
            $scope.tagsOptions = {
                allTags: [],
                tags: getSelectedCategories(angular.copy($scope.pageData.tags || []), true)
            };

            $scope.pageData.lang = $scope.pageData.lang || $scope.page.lang;
            preloadedItemData.item.lang = preloadedItemData.item.lang || $scope.page.lang;
            $scope.globalOptions = {
                isGlobalActionsAllowed: settings.allowGlobalActions
            };
        })();

        !$scope.pageData.customFields && ($scope.pageData.customFields = {
            parent: true,
            children: [

            ]
        });

        $scope.allPages = [];
        if ($scope.page.type == "news") {
            pagesService.getCategories({lang: preloadedItemData.page.lang, type: "category"}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.allCategories = angular.copy(response.pages);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            );
            settings.allowGlobalActions && categoryService.getTags({page_id: $scope.page.id}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.tagsOptions.allTags = angular.copy(response.items);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        } else if ($scope.page.type == "text") {
            pagesService.getCloserPages({id: $stateParams.itemId}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.allPages = angular.copy(response.pages);
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (error) {
                    errorHandler(error.message);
                }
            )
        }

        $scope.submitEditPageItemForm = function () {
            $scope.preview(function (dataUrl) {
                delete $scope.pageData.forceTOChange;
                var requestObj = {
                        item: $scope.pageData
                    },
                    changes;

                requestObj.item.page_id = $stateParams.pageId;

                !deepCompare.isEqual($scope.categoryOptions.categories, requestObj.item.categories) && (requestObj.item.categories = getSelectedCategories($scope.categoryOptions.categories));
                !deepCompare.isEqual($scope.tagsOptions.tags, requestObj.item.tags) && (requestObj.item.tags = getSelectedCategories($scope.tagsOptions.tags));

                if ($scope.page.type == "sidebar" || $scope.page.type == "text" || $scope.page.type == "news") {
                    !!$scope.vm.fromDate ? (requestObj.item.start_date = $scope.vm.fromDate) : ($scope.fromDateChanged && (requestObj.item.start_date = false));
                    !!$scope.vm.toDate ? (requestObj.item.end_date = $scope.vm.toDate) : ($scope.toDateChanged && (requestObj.item.end_date = false));
                }

                if ($scope.page.type != "text" && $scope.page.type != "category") {
                    delete requestObj.item.name
                }

                if ($scope.page.type != "sidebar") {
                    delete requestObj.item.action;
                    delete requestObj.item.align;
                    delete requestObj.item.video_link;
                    delete requestObj.item.linktarget
                }

                if (dataUrl != $scope.draggedImageDataUrl) {
                    if (!$scope.draggedImageDataUrl && !dataUrl && !!requestObj.item.image) {
                        requestObj.item.image = dataUrl || requestObj.item.image;
                    } else {
                        requestObj.item.image = dataUrl || "";
                    }
                }

                if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl) {
                    delete requestObj.item.image;
                    requestObj.item.media_id = $scope.imageToLoad.id
                }

                changes = deepCompare.getChanges(angular.copy(preloadedItemData.item), requestObj.item, false, {});
                if (!angular.equals(changes.customFields, requestObj.item.customFields)) {
                    changes.customFields = requestObj.item.customFields
                }

                changes.id = requestObj.item.id;
                changes.page_id = requestObj.item.page_id;


                pagesService.updatePageItem({item: changes}).then(
                    function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess("global.updated");
                            $scope.fromDateChanged = false;
                            $scope.toDateChanged = false;
                            //updatePageData
                            if (!!changes.categories) {
                                $scope.pageData.categories = getCurrentCategories();
                            }
                            if (!!changes.tags) {
                                $scope.pageData.tags = getCurrentTags();
                            }
                            preloadedItemData.item = angular.copy($scope.pageData)
                        }
                        else {
                            errorHandler(response.message)
                        }
                    },
                    function (error) {
                        errorHandler(error.message);
                    }
                );
            });
        };

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.fromDateChanged = true;
                $scope.vm.fromDate = dateToSave || undefined;
                $scope.pageData.start_date = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.toDateChanged = true;
                $scope.vm.toDate = dateToSave || undefined;
                $scope.pageData.end_date = $scope.vm.toDate;
            }
        };

        $scope.handleChangeOfStartDate = function (dateTime, dateToSave) {
            if ($scope.vm.created_at != dateTime) {
                $scope.vm.created_at = dateTime;
                $scope.createdAtChanged = true;
                $scope.vm.createdAt = dateToSave || undefined;
                $scope.pageData.created_at = $scope.vm.created_at;
            }
        };

        $scope.handleChangeOfCategory = function (pageId) {
            pagesService.groupCategory({page_id: pageId, count: "all"}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.categoryItems = angular.copy(response.items);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.getChanges = function (dontShowAnymore) {
            if (dontShowAnymore) {
                return true
            }
            if ($scope.newImageUploaded) {
                return false
            }
            return deepCompare.isEqual($scope.pageData, angular.copy(preloadedItemData.item));
        };

        $scope.onCategoryItemSelect
            = $scope.onCategoryItemDeselect
            = $scope.onCategorySelectAll
            = $scope.onCategoryUnselectAll
            = $scope.onTagsItemSelect
            = $scope.onTagsItemDeselect
            = $scope.onTagsSelectAll
            = $scope.onTagsUnselectAll
            = function () {
            $scope.pageData.forceTOChange = true
        };

        if ($scope.pageData.categoryPageId) {
            $scope.handleChangeOfCategory($scope.pageData.categoryPageId);
        }

        function getSelectedCategories(categories, fromArray) {
            var returnArray = [],
                index = 0;

            while (categories[index]) {
                if (!fromArray) {
                    returnArray.push(categories[index].id);
                } else {
                    returnArray.push(categories[index])
                }
                index++
            }
            return returnArray
        }

        function getCurrentCategories () {
            var i = 0,
                changes = [];

            var selectedCategoriesArray = getSelectedCategories($scope.categoryOptions.categories);

            while (selectedCategoriesArray[i]) {
                changes[i] = getCategoryFromList(selectedCategoriesArray[i]);
                i++;
            }

            return angular.copy(changes);
        }

        function getCurrentTags () {
            var i = 0,
                changes = [];

            var selectedTagsArray = getSelectedCategories($scope.tagsOptions.tags);

            while (selectedTagsArray[i]) {
                changes[i] = getTagFromList(selectedTagsArray[i]);
                i++;
            }

            return angular.copy(changes);
        }

        function getCategoryFromList (id) {
            var i = 0;
            while ($scope.categoryItems[i]) {
                var item = $scope.categoryItems[i];
                if (item["id"] == id) {
                    return {
                        id: item["id"],
                        title: item["title"]
                    }
                }
                i++;
            }
            return {}
        }

        function getTagFromList (id) {
            var i = 0;
            while ($scope.tagsOptions.allTags[i]) {
                var item = $scope.tagsOptions.allTags[i];
                if (item["id"] == id) {
                    return {
                        id: item["id"],
                        title: item["title"]
                    }
                }
                i++;
            }
            return {}
        }

        cropperService.call($scope);
    }
]);